import { render, staticRenderFns } from "./roll-transition.vue?vue&type=template&id=354d4d1d&scoped=true"
import script from "./roll-transition.vue?vue&type=script&lang=js"
export * from "./roll-transition.vue?vue&type=script&lang=js"
import style0 from "./roll-transition.vue?vue&type=style&index=0&id=354d4d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d4d1d",
  null
  
)

export default component.exports